import { Pipe, PipeTransform } from '@angular/core';

import { motivosPerdasVendasSituacaoes } from '../motivo-perda-venda-situacao';

@Pipe({
    name: 'motivoPerdaVendaSituacao'
})
export class MotivoPerdaVendaSituacaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = motivosPerdasVendasSituacaoes.findIndex(motivo => motivo.id === value);
        if (index > -1) {
            return motivosPerdasVendasSituacaoes[index].nome;
        }
        return '';
    }
}
